import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'includes',
    standalone: false
})
export class IncludesPipe implements PipeTransform{
  transform(array: any[], value: any) {
    return array.includes(value);
  }
}